import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-MQ8G25',
        },
    },
    host: 'www.zalando-lounge.ch',
});
